// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  BarChart,
  Props as BarChartProps,
  BarDatum,
} from '@/components/bar-chart';
import { SquareRounded } from '@/constants/hardfin-standard-icons';
import { Divider, Paper, Stack, Typography } from '@mui/material';

interface Props<Datum, Key> extends BarChartProps<Datum, Key> {
  title: string;
}

export function BarChartCard<Key extends string, Datum extends BarDatum<Key>>(
  props: Props<Datum, Key>
) {
  const { title, ...barChartProps } = props;

  return (
    <Paper variant="outlined" sx={{ display: 'flex', flexDirection: 'column' }}>
      <Stack
        spacing={1}
        padding={2}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="h6">{title}</Typography>
      </Stack>
      <Divider />
      <BarChart {...barChartProps} />
      <Divider sx={{ marginTop: 'auto' }} />
      <Stack
        direction="row"
        justifyContent="center"
        spacing={2}
        paddingX={2}
        paddingY={1}
      >
        {props.keys.map((key, index) => (
          <Stack key={key} direction="row" alignItems="center" spacing={1}>
            <SquareRounded
              fontSize="small"
              sx={{ fill: props.colors[index] }}
            />
            <Typography variant="body2">{props.getLabelForKey(key)}</Typography>
          </Stack>
        ))}
      </Stack>
    </Paper>
  );
}
